import { Component, OnInit } from '@angular/core';
import { AwsService } from '../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-remaininfo',
  templateUrl: './remaininfo.component.html',
  styleUrls: ['./remaininfo.component.css']
})
export class RemaininfoComponent implements OnInit {

  soscount = 0;
  compdrivercount = 0;
  markers = 0;
  totalTripCount = 0;
  triplist = [];
  runningcount=0;

  private interval = 1000 * 60 * 60 * 24
  private startOfDay = Math.floor(Date.now() / this.interval) * this.interval
  private endDate = new Date(this.startOfDay + this.interval - 1)
  private startDate = new Date(this.startOfDay)

  constructor(public awserviceProvider: AwsService) {

    this.configureSOS();
    this.scheduledTrips();

  }

  ngOnInit() {
  }

  configureSOS() {

    this.awserviceProvider.getOpenSos().then(sosdata => {
      this.soscount = sosdata.length
    })
  }

  scheduledTrips() {

    let dateFormat = require('dateformat');
    let now = new Date();
    let today = dateFormat(now, "yyyy-mm-dd");
   
    // this.awserviceProvider.getTripsByStatus(0, today).then(remaining => {
    //   var triplist: any = remaining;
    //   this.totalTripCount = triplist.length;
    // });
    // this.awserviceProvider.getTripsByStatus(1, today).then(running => {
    //   let runninglst: any = running;
    //   this.runningcount = runninglst.length

    // })

  }

}